import { TablePageLayout } from '@common/components/TablePageLayout';
import { DiscountDetailsDrawer } from '@features/discounts/components/DiscountDetailsDrawer';
import { DiscountsTable } from '@features/discounts/components/DiscountsTable';
import { DiscountsToolbar } from '@features/discounts/components/DiscountsToolbar';

export default function DiscountsPage() {
	return (
		<>
			<TablePageLayout
				title='Discounts'
				aboveTableContent={<DiscountsToolbar />}
				tableContent={<DiscountsTable />}
			/>
			<DiscountDetailsDrawer />
		</>
	);
}
